export default __webpack_public_path__ + "static/media/hc-2.4c3262cc.mp4";